<template>
  <div class="course flex">
      <van-image
            class="avater"
            src="https://img01.yzcdn.cn/vant/cat.jpeg"
          />
          <div>
            <div class="coursetitle van-multi-ellipsis--l2">
              这里是课程的标题，标题如果太长超过题如果太长超题如果太长超二行后显示
            </div>
            <div class="teacher">讲师：A讲师</div>
            <div class="flex jc-sb aic">
                <div class="learned">123人学习</div>
                <div class="free">限免</div>
            </div>
          </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.course{
    width: 100%;
    margin-top: 7px;
      .avater {
        width: 90px;
        height: 90px;
        border-radius: 5px;
        overflow: hidden;
        margin-right: 10px;
      }
      .coursetitle {
        width: 233px;
        height: 40px;
        line-height: 20px;
        color: rgba(48, 91, 119, 100);
        font-size: 14px;
        text-align: left;
        font-family: PingFangSC-regular;
      }
      .teacher {
        height: 17px;
        color: rgba(102, 102, 102, 100);
        font-size: 12px;
        text-align: left;
        font-family: PingFangSC-regular;
        margin-top: 8px;
      }
      .learned {
        color: rgba(153, 153, 153, 100);
        font-size: 12px;
        text-align: left;
        font-family: PingFangSC-regular;
      }
      .free {
        width: 40px;
        height: 20px;
        line-height: 17px;
        border-radius: 50px;
        background-color: rgba(229, 240, 249, 100);
        color: rgba(32, 139, 238, 100);
        font-size: 12px;
        text-align: center;
        font-family: -apple-system;
        border: 1px solid rgba(32, 139, 238, 100);
      }
}
</style>